module.exports = __webpack_public_path__ + "img/robot.21d11810.png";